import React from "react";
import { Link, useSearchParams } from "react-router-dom";
import QAConsole from "../components/QAConsole";
import { AlertCircle } from "lucide-react";

export default function ChairConsole() {
  const [params] = useSearchParams();
  const token = params.get("token") || "";

  if (!token) {
    return (
      <div className="min-h-screen bg-[#FAFAF8] flex items-center justify-center px-6">
        <div className="max-w-md rounded-3xl bg-white ring-1 ring-black/5 p-8 text-center" data-testid="chair-no-token">
          <div className="h-12 w-12 mx-auto rounded-full bg-amber-100 flex items-center justify-center">
            <AlertCircle className="text-amber-700" size={20} />
          </div>
          <h1 className="mt-4 font-heading text-2xl tracking-tight text-slate-900">Chair link required.</h1>
          <p className="mt-2 text-sm text-slate-600">
            Open this page from the link an admin shared with you. The link contains the access token.
          </p>
        </div>
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-[#FAFAF8]" data-testid="chair-console-page">
      <div className="border-b border-black/5 bg-white">
        <div className="max-w-5xl mx-auto px-6 sm:px-10 py-5 flex items-center justify-between">
          <Link to="/" className="leading-none" data-testid="chair-logo-link">
            <div className="flex items-baseline gap-0.5">
              <span className="font-heading text-xl font-black text-[#212121] tracking-tight">DFTB</span>
              <span className="font-heading text-xl font-black text-[#28BBE3] tracking-tight">26</span>
            </div>
            <div className="text-[9px] uppercase tracking-[0.22em] text-slate-500 font-bold mt-0.5">Chair console</div>
          </Link>
          <div className="text-xs text-slate-400 hidden sm:block">Mark questions asked or dismiss them as you go.</div>
        </div>
      </div>

      <div className="max-w-5xl mx-auto px-6 sm:px-10 py-8">
        <QAConsole
          token={token}
          title="Live questions"
          subtitle="From virtual viewers · auto-refreshes every 20s"
        />
      </div>
    </div>
  );
}
